/**
 * Scroll-reveal animations for brand sections.
 * Adds .is-visible when elements enter the viewport.
 * In the theme editor, content is always visible (no blank preview on section reload).
 */
(function () {
  function revealAll(rootEl) {
    rootEl.querySelectorAll('.brand-reveal').forEach((el) => el.classList.add('is-visible'));
  }

  function initBrandReveal(rootEl = document, designMode = false) {
    const elements = Array.from(rootEl.querySelectorAll('.brand-reveal'));
    if (elements.length === 0) return;

    if (designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealAll(rootEl);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach((el) => {
      if (!el.classList.contains('is-visible')) {
        observer.observe(el);
      }
    });
  }

  function initProductTilt(rootEl = document) {
    const tiltMedia =
      rootEl.querySelector('.brand-product__media--tilt') ||
      rootEl.querySelector('.brand-spotlight__media--tilt');
    if (!tiltMedia || !window.matchMedia('(min-width: 990px)').matches) return;

    const image =
      tiltMedia.querySelector('.brand-product__image') ||
      tiltMedia.querySelector('.brand-spotlight__image');
    if (!image || tiltMedia.dataset.tiltBound === 'true') return;

    tiltMedia.dataset.tiltBound = 'true';

    tiltMedia.addEventListener('mousemove', (e) => {
      const rect = tiltMedia.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;
      image.style.transform = `perspective(900px) rotateY(${x * 10}deg) rotateX(${-y * 10}deg) scale(1.03)`;
    });

    tiltMedia.addEventListener('mouseleave', () => {
      image.style.transform = '';
    });
  }

  function init(rootEl = document, designMode = false) {
    initBrandReveal(rootEl, designMode);
    initProductTilt(rootEl);
  }

  init(document, Boolean(window.Shopify && Shopify.designMode));

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => init(event.target, true));
    document.addEventListener('shopify:section:reorder', () => init(document, true));
    document.addEventListener('shopify:block:select', (event) => {
      const section = event.target.closest('.shopify-section');
      if (section) init(section, true);
    });
  }
})();
